<template>
  <div>
    <template v-if="loaded">
      <div class="columns">
        <div class="column">
          <div v-for="data in dynamicData" :key="data.identifier" class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ data.label }} - <i>({{ data.identifier }})</i>
            </p>
            <span class="has-text-weight-medium">{{ getValue(data) }}</span>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.last_name") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.lastName }}</span>
          </div>
        </div>
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.first_name") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.firstName }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.email") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.email }}</span>
          </div>
        </div>
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.phone") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.phone }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.date_of_birth") }}
            </p>
            <span class="has-text-weight-medium">{{
              localizedFormatter(country.languageIso).date(customer.dateOfBirth)
            }}</span>
          </div>
        </div>
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.place_of_birth") }}
            </p>
            <span class="has-text-weight-medium">{{
              customer.placeOfBirth
            }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.mothers_name") }}
            </p>
            <span class="has-text-weight-medium">{{
              customer.mothersName
            }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.post_code") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.postCode }}</span>
          </div>
        </div>
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.city") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.city }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.street") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.street }}</span>
          </div>
        </div>
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.house_number") }}
            </p>
            <span class="has-text-weight-medium">{{
              customer.houseNumber
            }}</span>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.is_risky") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.isRisky }}</span>
          </div>
        </div>
        <div class="column">
          <div class="mb-4">
            <p class="is-size-7 is-uppercase mb-1 has-text-grey-icon">
              {{ $t("customer:customer.base_data.is_trusted") }}
            </p>
            <span class="has-text-weight-medium">{{ customer.isTrusted }}</span>
          </div>
        </div>
      </div>
    </template>
    <LoadingSkeleton v-else />
  </div>
</template>

<script>
import LoadingSkeleton from "@/components/LoadingSkeleton";
import { FIELD_TYPE } from "@/utils/const";
import { localizedFormatter } from "@/utils/util";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  name: "BnplApplicationBaseData",
  components: {
    LoadingSkeleton,
  },
  props: {
    rawData: {
      type: Object,
      required: true,
    },
    flow: {
      type: Array,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      FIELD_TYPE,
    };
  },
  async mounted() {
    let promises = [];
    for (let s in this.flow) {
      let step = this.flow[s];
      for (let q in step.questions) {
        let question = step.questions[q];
        if (question.fieldType === "SIMPLE_FIELD")
          promises.push(
            this.$store.dispatch("simpleFieldStore/fetchOne", question.fieldId)
          );
      }
    }
    await Promise.all(promises);
    this.loaded = true;
  },
  methods: {
    localizedFormatter,
    getValue(data) {
      if (data.type === FIELD_TYPE.SELECT || data.type === FIELD_TYPE.RADIO) {
        let inputValue = data.inputValues.find(
          (inputValue) => inputValue.value === data.value
        );
        return inputValue ? inputValue.text : data.value;
      } else if (data.type === FIELD_TYPE.CHECKBOX) {
        if (data.value && data.value.startsWith("[")) {
          let texts = [];
          JSON.parse(data.value).forEach((value) => {
            let inputValue = data.inputValues.find(
              (inputValue) => inputValue.value === value
            );
            texts.push(inputValue ? inputValue.text : value);
          });
          return texts.join("; ");
        }
        return data.value;
      } else {
        return data.value;
      }
    },
  },
  computed: {
    ...mapGetters({
      country: "i18n/country",
    }),
    dynamicData() {
      let datas = [];
      let sortedFlows = [...this.flow].sort((a, b) => a.rowIndex - b.rowIndex);
      for (let s in sortedFlows) {
        let sortedQuestions = [...sortedFlows[s].questions].sort(
          (a, b) => a.rowIndex - b.rowIndex
        );
        for (let q in sortedQuestions) {
          let question = sortedQuestions[q];
          if (question.fieldType === "SIMPLE_FIELD") {
            let field = this.$store.getters["simpleFieldStore/get"](
              question.fieldId
            );
            datas.push({
              identifier: field.identifier,
              value: this.rawData[field.identifier],
              label: field.label,
              type: field.type,
              inputValues: field.inputValues,
            });
          }
        }
      }
      return datas;
    },
  },
};
</script>

<style scoped></style>
